import { useEffect } from 'react';
import PageSeo from '@/seo/PageSeo';
import { useSearchParams } from 'react-router-dom';
import AboutContent from '../components/About/AboutContent';
import DocsHub from '../components/About/DocsHub';
import $ from 'jquery';

export default function About() {
  const [searchParams] = useSearchParams();
  const hasParams =
    searchParams.has('section') || searchParams.has('version') || searchParams.has('subsection');

  useEffect(() => {
    $('.popover').hide();
  }, []);

  return (
    <>
      <PageSeo
        title="Gene-Disease Database Documentation | DISGENET"
        description="Sources, metrics and statistics for DISGENET gene-disease and variant-disease associations, including scoring, ontologies and how to cite."
        path="/docs"
      />
      {hasParams ? <AboutContent /> : <DocsHub />}
    </>
  );
}
